import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import selectComp from './select.vue';
export default {
  meta: {
    title: '选择商品分类',
    auth: true,
    authorityValue: "store-goods-add"
  },
  name: 'addTrade',
  components: {
    selectComp: selectComp
  },
  data: function data() {
    return {
      value: '',
      panel_value: '',
      props: {
        lazy: true,
        lazyLoad: this.lazyLoad,
        label: 'typeName',
        value: 'goodsTypeId'
      }
    };
  },
  created: function created() {},
  methods: {
    selectCompChange: function selectCompChange(e, item) {
      this.panel_value = e;
      this.value = item.map(function (v) {
        return v.label;
      }).join(' > ');
    },
    lazyLoad: function lazyLoad(node, resolve) {
      var level = node.level,
          data = node.data;
      var obj = {
        typeLevel: level + 1,
        preTypeId: data === null || data === void 0 ? void 0 : data.goodsTypeId
      };
      this.getGoodsTypes(obj, resolve);
    },
    //获取类目
    getGoodsTypes: function getGoodsTypes(data, resolve) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, o;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.goodsTypes(_objectSpread({
                  pageNo: 1,
                  pageSize: 99
                }, data));

              case 2:
                res = _context.sent;
                o = res.records;
                resolve(o);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    goRoute: function goRoute(name, query) {
      if (this.panel_value.length <= 0) {
        return YL.message("\u8BF7\u9009\u62E9\u5206\u7C7B", 'error');
      }

      this.$router.push({
        name: name,
        query: {
          goodsTypeIdFirst: this.panel_value[0],
          goodsTypeIdSecond: this.panel_value[1],
          goodsTypeId: this.panel_value[2],
          goodsTit: this.value
        }
      });
    }
  }
};